export default {
    namespaced: true,
    //状态
    state: {
    },
    //方法
    actions: {
        setBtn(statu) {
        }
    },

}